import { render, staticRenderFns } from "./collectionAgreement4Mobile.vue?vue&type=template&id=69a8a395&scoped=true"
import script from "./collectionAgreement4Mobile.vue?vue&type=script&lang=js"
export * from "./collectionAgreement4Mobile.vue?vue&type=script&lang=js"
import style0 from "./collectionAgreement4Mobile.vue?vue&type=style&index=0&id=69a8a395&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a8a395",
  null
  
)

export default component.exports